var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSightingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.0003C14 24.0003 17.3333 16.667 24 16.667C30.6667 16.667 34 24.0003 34 24.0003C34 24.0003 30.6667 31.3337 24 31.3337C17.3333 31.3337 14 24.0003 14 24.0003Z",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 27.3337C25.841 27.3337 27.3334 25.8413 27.3334 24.0003C27.3334 22.1594 25.841 20.667 24.0001 20.667C22.1591 20.667 20.6667 22.1594 20.6667 24.0003C20.6667 25.8413 22.1591 27.3337 24.0001 27.3337Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightingsActive);
export default __webpack_public_path__ + "static/media/sightings-active.1af49b01cf5629ff217b061ffb833be3.svg";
export { ForwardRef as ReactComponent };